import { Navigate, Outlet } from 'react-router-dom';

const AuthenticatedRoute = ({ isAuthenticated }) => {
    return isAuthenticated ? <Outlet /> : <Navigate to="/access-denied" />;
};

export default AuthenticatedRoute;
